import { DailyMenuSettings } from 'features/DailyMenu/models';
import { CommonResponse, TargetMenu } from 'models';
import axiosClient from 'utils/axiosClient';

export interface Response {
  status: string;
  message: string;
  data: DailyMenuSettings;
}

const service = {
  async get(): Promise<Response> {
    const url = `daily-menu-settings/`;
    return await axiosClient.get(url);
  },
  async update(data: DailyMenuSettings): Promise<Response> {
    const url = `update-daily-menu-settings/`;
    return await axiosClient.put(url, data);
  },
  convertWeekday(weekday: number): string {
    const weekdays = ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'];
    return weekdays[weekday] || 'Invalid weekday';
  },
  listMenus(id: number): Promise<CommonResponse<TargetMenu[]>> {
    const url = '/day-of-week-menus';
    return axiosClient.get(`${url}/${id}`);
  },
  addMenus(id: number, menuIds: number[]): Promise<CommonResponse<DailyMenuSettings>> {
    const url = '/day-of-week-menus';
    const body = { id: id, target_menu_ids: menuIds };
    return axiosClient.post(`${url}`, body);
  },
  deleteMenus(id: number, menuIds: number[]): Promise<CommonResponse<DailyMenuSettings>> {
    const url = '/day-of-week-menus';
    const body = { id: id, target_menu_ids: menuIds };
    return axiosClient.delete(url, { data: body });
  },
  listHolidayMenus(id: number): Promise<CommonResponse<TargetMenu[]>> {
    const url = '/holiday-menus';
    return axiosClient.get(`${url}/${id}`);
  },
  addHolidayMenus(id: number, menuIds: number[]): Promise<CommonResponse<DailyMenuSettings>> {
    const url = '/holiday-menus';
    const body = { id: id, target_menu_ids: menuIds };
    return axiosClient.post(`${url}`, body);
  },
  deleteHolidayMenus(id: number, menuIds: number[]): Promise<CommonResponse<DailyMenuSettings>> {
    const url = '/holiday-menus';
    const body = { id: id, target_menu_ids: menuIds };
    return axiosClient.delete(url, { data: body });
  },
};

export default service;
